/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.6.0 (NJsonSchema v10.0.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { EstimateIntegrationDto } from "./GeneratedClients/insights";

export class AuthClient {
  constructor(private accessToken: string) {}

  transformHttpRequestOptions(options: RequestInit): Promise<RequestInit> {
    if (options.headers) {
      options.headers = new Headers(options.headers);
      options.headers.set("Authorization", "Bearer " + this.accessToken);
    }

    return Promise.resolve(options);
  }
}

export class PreConClientBase {
  constructor(private authClient: AuthClient) {}
  transformOptions(options: RequestInit): Promise<RequestInit> {
    return this.authClient
      ? this.authClient.transformHttpRequestOptions(options)
      : Promise.resolve(options);
  }
}

export interface SchemaField {
  id: string;
  name: string;
  type: SchemaFieldType;
  config: { [key: string]: any };
  readOnly: boolean;
  required: boolean;
  adminOnly?: boolean;
  companyAdminOnly?: boolean;
  standard: boolean;
  protected: boolean;
  hiddenInTable: boolean;
  hiddenInForm: boolean;
  hiddenInEdit?: boolean;
  lookup: boolean;
  isLockable: boolean;
}

export type TableFieldRowSchema = Pick<SchemaField, "name" | "type" | "config"> 

export enum SchemaFieldType {
  ShortText = 0,
  LongText = 1,
  Date = 2,
  List = 3,
  States = 4,
  Custom = 5,
  Boolean = 6,
  Number = 7,
  Currency = 8,
  DateTime = 9,
  Estimates = 10,
  BidResults = 11,
  Links = 12,
  PhoneNumber = 13,
  Checklist = 14,
  Location = 15,
  MultiSelectList = 16,
  PreConId = 17,
  Company = 18,
  Contact = 19,
  HJJob = 20,
  Table = 21,
  Calculated = 22,
  Takeoffs = 23
}

export interface HeavyBidProjectResponse {
  projects?: any[] | undefined;
  continuationToken?: string | undefined;
}

export interface QueryOptions {
  orderBy?: UriOrderBy | undefined;
  continuationToken?: string | undefined;
  top?: number;
  filters?: string | undefined;
  search?: DynamicSearchOptions | undefined;
}

export interface UriOrderBy {
  fieldId?: string | undefined;
  ascending?: boolean;
}

export interface DynamicSearchOptions {
  fields?: string | undefined;
  value?: string | undefined;
}

export interface SignalRChanges {
  companyId: string;
  changes: { [key: string]: string[] };
}

export interface PermissionsDTO {
  userPermissions: UserPermissionsDTO[];
  companyPermissions: PreConPermissions;
}

export interface UserPermissionsDTO {
  id: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  username?: string | undefined;
  userRole?: string | undefined;
  isAddEdit: boolean;
  isContactAddEdit: boolean;
  isHeavyBidNumbers: boolean;
  isAdmin: boolean;
  hasEstimateInsights: boolean;
  preConUser?: boolean;
  credentialsAdmin?: boolean;
}

export interface PreConPermissions {
  admin: boolean;
  write: boolean;
  contactWrite?: boolean;
  heavyBidNumbers: boolean;
  estimateInsights: boolean;
}

export interface BaseEntity {
  id?: string | undefined;
  lastModified?: Date;
  dateCreated?: Date;
  lastModifiedByUserId?: string | undefined;
  lastModifiedByClientId?: string;
  lastModifiedBySystemUser: boolean;
  deleted?: boolean;
}

export interface CompanyEntity extends BaseEntity {
  companyId?: string | undefined;
  cosmosEntityName?: string | undefined;
}

export interface UserEntity extends CompanyEntity {
  userId?: string | undefined;
}

export interface Calendar extends UserEntity {
  viewId?: string | undefined;
  lastPing?: Date | undefined;
  token?: string | undefined;
  accountId?: string | undefined;
  calendarId?: string | undefined;
  isNylas?: boolean | undefined;
}

export interface CosmosPagedResultsOfCalendar {
  results?: Calendar[] | undefined;
  nextPageToken?: string | undefined;
  hasNextPage?: boolean;
}

export interface FeatureFlag {
  key: string;
  active: boolean;
}

export interface ConfigurationSettings {
  featureFlags: FeatureFlag[];
}

export interface CosmosPagedResultsOfEstimate {
  results?: EstimateEntity[] | undefined;
  nextPageToken?: string | undefined;
  hasNextPage?: boolean;
}

export interface EstimateEntity extends CompanyEntity {
  values: EstimateIntegrationDto;
}

export interface UpdateEstimateDTO {
  estimateId: string;
  companyId: string;
}

export interface OAuthInfoModel {
  email?: string | undefined;
  needsRefresh: boolean;
}

export interface SendEmailViaModel {
  sendVia: SendEmailVia;
}

export enum SendEmailVia {
  Mailgun = "Mailgun",
  SMTP = "SMTP",
  OAuth = "OAuth"
}

export interface SettingsModel {
  businessUnitId?: string;
  info?: SMTPInfoModel | undefined;
}

export interface SMTPInfoModel {
  smtpServer?: string | undefined;
  smtpPort: number;
  smtpUser?: string | undefined;
  smtpPassword?: string | undefined;
}

export interface FieldMetadata {
  isLocked: boolean;
}
export interface Project extends CompanyEntity {
  /**
   * Optional - The location Id (HeavyJob) that linked to the project.
   */
  locationId?: string | undefined;
  fields: { [key: string]: any };
  fieldsMetadata?: { [key: string]: FieldMetadata };
  warnings?: any[];
}

export interface CosmosPagedResultsOfProject {
  results?: Project[] | undefined;
  nextPageToken?: string | undefined;
  hasNextPage?: boolean;
}

export interface Schema extends CompanyEntity {
  fields: { [key: string]: SchemaField };
  sections: { [key: string]: SchemaSection };
  orderedSections: string[];
  schemaName: string;
  dataSyncPreference?: string;
}

export interface SchemaSection {
  id: string;
  name: string;
  fields: string[];
}

export interface CosmosPagedResultsOfSchema {
  results?: Schema[] | undefined;
  nextPageToken?: string | undefined;
  hasNextPage?: boolean;
}

export interface SolicitationPreviewModel {
  mapping?: FolderVendorMap[] | undefined;
}

export interface FolderVendorMap {
  folderId?: string | undefined;
  vendorCodes?: string[] | undefined;
}

export interface SendSolicitationModel {
  businessUnitId: string;
  method: SendEmailVia2;
  subject: string;
  vendorSolicitationIds: string[];
}

export enum SendEmailVia2 {
  Mailgun = 0,
  SMTP = 1,
  OAuth = 2
}

export interface CurrentUser {
  companyId: string;
  businessUnitId: string;
  userId: string;
  businessUnitName: string;
  firstName: string;
  lastName: string;
  role: string;
  companyName: string;
  email: string;
  accessToken: string;
  firebaseAccessToken: string;
  preConEnabledForCompany: boolean;
  preConEnabledForUser: boolean;
  isAdmin: boolean;
  isAddEdit: boolean;
}

export interface UserPreferences extends UserEntity {
  tablePreferences?: { [key: string]: UserTablePreferences } | undefined;
  tutorials?: Tutorials | undefined;
  region?: string | undefined;
}

export interface UserTablePreferences {
  id: string;
  selectedView: string;
}

export interface Tutorials {
  projectsList?: boolean;
}

export interface View extends CompanyEntity {
  id: string;
  schemaId: string;
  viewSchemaId?: string;
  viewType?: ViewType;
  name: string;
  grouping: SchemaViewGrouping[];
  subGroupBy?: Record<string, string>[];
  columnSummaries: ColumnSummary[];
  sorting: SchemaViewSorting[];
  hiddenColumns: string[];
  displayedColumns: string[];
  ordering: string[];
  filters: { [key: string]: SchemaViewFilter };
  coloringColumnName?: string | undefined;
  mapActive?: boolean;
  satelliteMapStyleActive?: boolean;
  listActive?: boolean;
  calendarActive?: boolean;
  chartsActive?: boolean;
  chartConfigs: { [key: string]: any }[];
  chartConfig: { [key: string]: any };
  layout?: { [key: string]: any };
  calendarConfig?: { [key: string]: any };
  createdByUserId?: string;
  isPublic: boolean;
}

export enum ViewType {
  Basic,
  OldBidResults,
  NewBidResults
}

export interface ColumnSummary {
  columnName: string;
  type: SummaryType;
}

enum SummaryType {
  Sum = "sumDefaultZero",
  Avg = "avgNoNulls",
  Count = "count"
}

export interface SchemaViewGrouping {
  columnName: string;
}

export interface SchemaViewSorting {
  columnName: string;
  direction: string;
}

export interface SchemaViewFilter {
  columnName: string;
  filterOperation?: FilterOperation;
  value?: any | undefined;
  config?: any;
}

export enum FilterOperation {
  Contains = 0,
  GreaterThan = 1,
  GreaterThanOrEqualTo = 2,
  LessThan = 3,
  LessThanOrEqualTo = 4,
  Between = 5,
  StartsWith = 6,
  EndsWith = 7,
  Any = 8,
  None = 9,
  Equals = 10,
  NotEquals = 11
}

export interface CosmosPagedResultsOfView {
  results?: View[] | undefined;
  nextPageToken?: string | undefined;
  hasNextPage?: boolean;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export interface LocationDto {
  id: string;
  description: string;
  associatedProducts: string;
  businessUnitId: string;
  code: string;
  locationTypeId: number;
  isDeleted: boolean;
}

export interface JobDto {
  id: string;
  code: string;
  description: string;
  businessUnitId: string;
  status: string;
  latitude: number | null;
  longitude: number | null;
  startofpayweek: string;
  truckingCostTypeId: string;
  jobNote: string;
  relatedEstimateCodes: string[];
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

export interface Amounts {
  actual: number
  expected: number;
  budgeted: number;
  variance: number;
}

export interface JobCostType {
  id: string;
  type: string;
  description: string;
  cost: Amounts;
  hours: Amounts;
}

export interface JobCostTypeCostDto {
  jobId: string;
  jobCode: string;
  jobStatus: string;
  costTypes: JobCostType[];
}

export interface ProjectValidationErrorDto {
  fieldId: string;
  fieldName: string;
  message: string;
  invalidValue: unknown;
}

export interface ProjectValidationWarningDto {
  fieldId: string;
  message: string;
  warningValue: unknown;
}

export interface ProjectValidationResultDto {
  entry: Project;
  errors: ProjectValidationErrorDto[];
  warnings: ProjectValidationWarningDto[];
  index: number;
}
